import { hasPermission } from '@/utils/authorization'

const elements = new WeakMap()

function updateVisibility (el, state) {
  const user = state.context && state.context.$store ? state.context.$store.state.user : {}
  const allowed = hasPermission(user, state.required)
  if (!allowed) {
    if (!state.hidden || el.style.display !== 'none') {
      state.display = el.style.display
      state.priority = el.style.getPropertyPriority('display')
    }
    el.style.setProperty('display', 'none', 'important')
  } else if (state.hidden) {
    if (state.display) el.style.setProperty('display', state.display, state.priority)
    else el.style.removeProperty('display')
  }
  state.hidden = !allowed
}

/** Hide denied actions without detaching Vue-managed nodes; follow permission refreshes. */
export default {
  bind (el, binding, vnode) {
    const state = { context: vnode.context, required: binding.value, hidden: false }
    elements.set(el, state)
    updateVisibility(el, state)
    if (state.context && state.context.$watch) {
      state.unwatch = state.context.$watch(
        () => state.context.$store ? state.context.$store.state.user : {},
        () => updateVisibility(el, state),
        { deep: true }
      )
    }
  },
  componentUpdated (el, binding) {
    const state = elements.get(el)
    state.required = binding.value
    updateVisibility(el, state)
  },
  unbind (el) {
    const state = elements.get(el)
    if (state.unwatch) state.unwatch()
    elements.delete(el)
  }
}
